import React from 'react';
import { Typography } from '@mui/material';
import './styles.css';

type PropTypes = {
  playerInput: string;
};

export const StagedPlayerInput = ({ playerInput }: PropTypes) => {
  return (
    <Typography
      variant="h5"
      color="success.main"
      paddingY="5px"
      paddingX="20px"
      textAlign={'center'}
    >
      {playerInput}
    </Typography>
  );
};
